import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import despreNoi from "assets/images/despreNoi.webp";
import generala9 from "assets/images/poze-site/7-9-generala.webp";
import generala3 from "assets/images/poze-site/7-3-generala.webp";

function ArticleContent() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        {/* Title - Visual Heading (h2 in DOM to preserve heading hierarchy) */}
                        <MKTypography variant="h1" component="h2" mb={3} color="dark">
                            Curățenie generală profesională pentru locuințe, birouri și spații comerciale
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            O curățenie generală bine făcută schimbă imediat felul în care arată un spațiu. Diferența se vede în detalii: suprafețe curate, băi igienizate, bucătării puse la punct, geamuri fără urme și o senzație reală de ordine.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Doral Cleaning oferă servicii de curățenie generală pentru locuințe, birouri și spații comerciale, adaptate în funcție de tipul spațiului, gradul de încărcare și operațiunile necesare. Primești exact serviciile de care ai nevoie, fără pachete rigide și fără costuri neclare.
                        </MKTypography>

                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Curățenia Generală Detaliată
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Este un serviciu impecabil, în care suprafețele sunt tratate până la cele mai fine detalii: retușuri post-construcție, feronerie, chedere și sisteme de etanșare, precum și îndepărtarea siliconului, spumei poliuretanice, adezivilor, foliei lichide și a materialelor decorative.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Aplicăm tratamente cu abur, degresări, decapări și detartrări cu echipamente moderne și personal calificat. Serviciul este potrivit pentru locuințe, restaurante și bucătării, hoteluri, birouri clasa A, spații tehnice, laboratoare medicale și farmaceutice, producție alimentară și showroom-uri.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={despreNoi}
                            alt="Curățenie generală profesională pentru locuințe și spații comerciale"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Ce înseamnă curățenia generală și când este necesară
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia generală este o intervenție amplă, mai complexă decât curățenia de întreținere. Nu înseamnă doar ștergerea rapidă a suprafețelor vizibile, ci curățarea atentă a zonelor în care se acumulează praf, urme, grăsime, calcar și alte depuneri.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            În locuințe, acest serviciu este util atunci când vrei să readuci spațiul la un nivel bun de curățenie și confort. În birouri și spații comerciale, ajută atât la menținerea igienei, cât și la păstrarea unei imagini îngrijite.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Curățenia generală este potrivită atunci când vrei mai mult decât întreținerea de rutină și ai nevoie de o intervenție completă, făcută atent și organizat.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={generala9}
                            alt="Curățenia generală profesională pentru apartamente, case și birouri"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Când ai nevoie de curățenie generală
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Acest serviciu este solicitat frecvent:
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">înainte de mutare</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">după mutare</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">după chiriași</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">după o renovare ușoară</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">la început de sezon</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">atunci când spațiul nu a mai fost curățat temeinic de ceva timp</MKTypography>
                        </MKBox>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În cazul spațiilor comerciale sau al birourilor, curățenia generală este utilă înainte de deschidere, după reamenajări sau înaintea unor vizite importante.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/LhkCkggb/cand-curatenie-generala.jpg"
                            alt="Situații în care este necesară curățenia generală"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Diferența dintre curățenia generală și curățenia de întreținere
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Curățenia de întreținere se face periodic și are rolul de a păstra spațiul curat de la o zi la alta. Curățenia generală merge mai în profunzime și vizează inclusiv zonele unde murdăria se acumulează în timp.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pe scurt, întreținerea menține. Curățenia generală readuce spațiul la un standard mai bun de curățenie. Dacă după această intervenție ai nevoie de menținere periodică, poți continua cu serviciul de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-de-intretinere"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie de întreținere
                            </MKTypography>.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Ce include serviciul de curățenie generală profesională
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            O curățenie generală bine făcută înseamnă mai mult decât aspirare și spălatul podelelor. Este o intervenție completă, care urmărește curățarea atentă a întregului spațiu, inclusiv a zonelor care, de obicei, rămân în afara curățeniei de rutină.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            În funcție de tipul locației și de gradul de murdărie, serviciul poate include aspirarea completă a pardoselilor, a pereților, a mobilierului, a corpurilor de iluminat și a caloriferelor, pentru îndepărtarea eficientă a prafului și a depunerilor. În același timp, mobilierul este șters cu soluții antistatice, astfel încât suprafețele să rămână curate mai mult timp și să capete un aspect îngrijit.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia generală poate cuprinde și spălarea geamurilor, a tocurilor, a pervazurilor și a jaluzelelor, precum și curățarea prizelor, a întrerupătoarelor, a ușilor și a tocurilor, elemente care adună rapid urme și murdărie în orice spațiu.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Atunci când este necesar, se curăță atent și aparatura de birou sau electrocasnicele, iar suprafețele dure, cum sunt gresia, marmura, linoleumul sau mozaicul, sunt spălate și curățate în funcție de specificul materialului. În băi, grupuri sanitare și bucătării, accentul cade pe igienizare și dezinfectare, pentru ca spațiul să fie nu doar curat vizibil, ci și bine întreținut din punct de vedere sanitar.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pentru anumite intervenții, serviciul poate include și spălarea mecanizată a mochetelor, covoarelor și tapiseriilor. La final, curățenia este completată, după caz, prin evacuarea gunoiului, înlocuirea sacilor menajeri, aerisirea încăperilor și odorizarea spațiului.
                        </MKTypography>

                        <MKTypography variant="body1" fontWeight="bold" color="dark" mb={2}>
                            Pe scurt, serviciul poate include:
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">aspirare completă a pardoselilor, pereților, mobilierului, corpurilor de iluminat și caloriferelor;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">ștergerea prafului de pe mobilier cu soluții antistatice;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">spălarea geamurilor, tocurilor, pervazurilor și jaluzelelor;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">curățarea prizelor, întrerupătoarelor, ușilor și tocurilor;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">curățarea aparaturii de birou și a electrocasnicelor;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">curățarea suprafețelor dure, precum gresie, marmură, linoleum și mozaic;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">igienizarea și dezinfectarea băilor, grupurilor sanitare și bucătăriilor;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">spălarea mecanizată a mochetelor, covoarelor și tapiseriilor, acolo unde este necesar;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">evacuarea gunoiului și înlocuirea sacilor menajeri;</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">aerisirea și odorizarea încăperilor.</MKTypography>
                        </MKBox>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/QvNNYHDf/ce-include-curateia-generala.jpg"
                            alt="Ce include serviciul de curățenie generală profesională"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        <MKTypography variant="body1" color="text" mb={2}>
                            Intervenția se desfășoară etapizat, astfel încât fiecare zonă să fie curățată corect și eficient. La Doral Cleaning, serviciul este adaptat după tipul spațiului și nevoile reale ale clientului: apartament, casă, birou sau spațiu comercial.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Curățenie pentru apartamente și case
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În locuințe, atenția se concentrează pe zonele care influențează cel mai mult confortul de zi cu zi: bucătărie, baie, living, dormitoare, holuri și spații de depozitare ușor accesibile. Se urmărește îndepărtarea prafului, a urmelor, a petelor uzuale, a depunerilor de calcar și a grăsimii acumulate în timp. Acest tip de curățenie este foarte util înainte de mutare, după chiriași sau atunci când vrei să pui locuința în ordine fără să consumi timp și energie.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Curățenie pentru birouri și spații comerciale
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În birouri și spații comerciale, curățenia generală are un rol practic, dar și unul de imagine. Un spațiu curat transmite organizare și seriozitate, atât pentru angajați, cât și pentru clienți. Sunt vizate zonele de lucru, recepțiile, grupurile sanitare, zonele comune, birourile, ușile, mânerele, vitrinele interioare și alte suprafețe care se murdăresc rapid.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={generala3}
                            alt="Curatenie generala Birouri"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Curățarea geamurilor și a suprafețelor vitrate
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Geamurile curate schimbă imediat aspectul unei încăperi. Lasă mai multă lumină, oferă un aspect îngrijit și completează foarte bine o curățenie generală. În cadrul curățeniei generale pot fi incluse geamurile interioare și alte suprafețe vitrate ușor accesibile. Pentru intervenții dedicate, poți vedea și serviciul de{" "}
                            <MKTypography
                                component="a"
                                href="/curatare-geamuri-suprafete-vitrate"
                                color="info"
                                fontWeight="medium"
                            >
                                curățare geamuri și suprafețe vitrate
                            </MKTypography>.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Cum se desfășoară o intervenție de curățenie generală
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            O curățenie generală eficientă începe cu evaluarea corectă a spațiului. Nu toate spațiile au aceleași nevoi, iar volumul de lucru poate diferi mult în funcție de suprafață, gradul de murdărie și tipul intervenției.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            La Doral Cleaning, procesul începe cu analiza spațiului și stabilirea clară a operațiunilor incluse. Apoi se estimează durata lucrării, necesarul de echipamente și costul. Intervenția este organizată pe etape, iar la final se verifică rezultatul. Astfel, clientul știe din start ce este inclus și pentru ce plătește.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Evaluarea spațiului și stabilirea necesarului de lucru
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În această etapă contează suprafața, tipul spațiului, gradul de încărcare, accesul în locație și eventualele servicii suplimentare. Un apartament locuit constant are alte nevoi decât un birou sau un spațiu gol pregătit pentru închiriere. De aceea, oferta trebuie făcută în funcție de situația reală din teren.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Etapele principale ale curățeniei
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Intervenția urmează o ordine logică. Se începe cu organizarea zonei de lucru, apoi se îndepărtează praful și murdăria de pe suprafețe, se insistă pe băi și bucătării, se curăță geamurile și oglinzile unde este cazul, iar la final se tratează podelele și se fac finisajele. Ordinea contează, pentru că un rezultat bun depinde de pași clari și de atenție la detalii.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Ce influențează prețul serviciilor de curățenie
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Întrebarea firească este: cât costă o curățenie generală? Prețul depinde de mai mulți factori, nu doar de numărul de metri pătrați.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Contează suprafața, gradul de murdărie, tipul spațiului, timpul estimat de lucru, accesul și serviciile incluse. O curățenie generală într-un apartament bine întreținut nu presupune același efort ca una într-un spațiu comercial intens circulat sau într-o locuință după lucrări. Din acest motiv, Doral Cleaning lucrează cu oferte personalizate, calculate în funcție de necesarul real.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/q302LSTw/factori-pret-curatenie-generala.jpg"
                            alt="Factori care influențează prețul curățeniei generale"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Suprafața, gradul de murdărie și tipul spațiului
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Suprafața influențează durata intervenției, dar nu este singurul criteriu important. Un spațiu mai mic, dar foarte încărcat, poate necesita mai mult timp decât unul mai mare, bine întreținut. Bucătăriile cu depuneri de grăsime, băile cu urme persistente, birourile cu trafic intens sau spațiile comerciale folosite zilnic presupun un volum de lucru diferit.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Servicii suplimentare care pot fi incluse în ofertă
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În unele situații, curățenia generală poate fi completată cu servicii suplimentare, cum ar fi curățarea detaliată a geamurilor sau o intervenție după lucrări. Dacă spațiul a trecut recent prin renovări sau amenajări, poate fi mai potrivit și serviciul de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-post-construct"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie post constructor
                            </MKTypography>
                            . Iar dacă vrei să menții rezultatele în timp, poți opta și pentru{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-de-intretinere"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie de întreținere
                            </MKTypography>
                            .
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            De ce să alegi Doral Cleaning
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Când alegi o firmă de curățenie, nu cauți doar o echipă care vine cu produse și echipamente. Cauți seriozitate, organizare, atenție la detalii și o comunicare clară.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Doral Cleaning pune accent pe intervenții bine planificate, servicii adaptate spațiului și rezultate vizibile. Pentru client, asta înseamnă mai puțin timp pierdut, mai puțin efort și un spațiu curat, pregătit pentru locuit, lucru sau primirea clienților.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Beneficiile colaborării cu o firmă de curățenie profesionistă
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Principalul avantaj este timpul câștigat. O curățenie generală făcută temeinic cere ore multe de muncă și atenție constantă. Când intervenția este realizată profesionist, nu mai pierzi zile întregi cu produse, etape și efort fizic. În plus, rezultatul este mai ușor de menținut apoi prin servicii periodice.
                        </MKTypography>

                        <MKBox p={3} mb={3} mt={4} bgcolor="light.main" borderRadius="lg">
                            <MKTypography variant="h5" mb={1} color="info">
                                Solicită acum o ofertă!
                            </MKTypography>
                            <MKTypography variant="body2" color="text">
                                Dacă ai nevoie de curățenie generală pentru apartament, casă, birou sau spațiu comercial, Doral Cleaning îți poate pregăti o ofertă adaptată spațiului tău și volumului real de lucru. Spune-ne ce tip de locație ai, suprafața aproximativă și ce servicii vrei incluse. În funcție de aceste informații, primești o evaluare clară și o propunere potrivită.
                                <br />
                                <br />
                                Contactează-ne prin pagina de <MKTypography component="a" href="/contact-curatenie" color="info" fontWeight="medium">contact</MKTypography> sau la telefon <strong>0730 407 322</strong>
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
